import clsx from 'clsx';
import type { CSSProperties, ReactNode } from 'react';
import { memo } from 'react';

import type { Slot } from '../types';
import { SlotType } from '../types';

import CardHeader from './CardHeader';

import { trackCardElement } from '@services/GoogleTagManagerService';

import * as classes from './styles.module.scss';

const CardContainer = ({
  children,
  slot,
  backgroundImage,
  href,
  tracking,
}: {
  children: ReactNode;
  slot: Slot;
  backgroundImage?: string;
  href?: string;
  tracking?: Record<string, any>;
}) => {
  const isMatchSlot = slot.type === SlotType.MATCH;
  const isDrawSlot = slot.type === SlotType.DRAW;
  const isMatchDaySlot = slot.type === SlotType.MATCHDAY;

  const isLightCard = [SlotType.PLACEHOLDER, SlotType.MATCH].includes(slot.type);
  const theme = isLightCard ? 'light' : 'dark';

  const Tag = href ? 'a' : 'div';

  return (
    <Tag
      key={tracking ? 'tracking' : 'no-tracking'}
      className={clsx(
        'football-rail__slot',
        'pk-d--flex',
        'pk-flex--column',
        'pk-justify-content--between',
        'pk-align-items--start',
        'pk-bg--elevation-01',
        'pk-gap--xs2',
        'pk-p--m',
        'pk-rounded--xl',
        'pk-text--text-01',
        isLightCard && 'pk-border',
        isMatchSlot && 'pk-pb--0',
        isDrawSlot && classes.cardDraw,
        isMatchDaySlot && classes.cardMatchDay,
      )}
      style={
        {
          '--background-image': backgroundImage,
        } as CSSProperties
      }
      href={href}
      target='_blank'
      pk-theme={theme}
      ref={trackCardElement(tracking, !href)}
    >
      {slot.competition && <CardHeader competition={slot.competition} theme={theme} />}
      {children}
    </Tag>
  );
};

export default memo(CardContainer);
